/**
 * @hidden
 */
export var FIELD_REGEX = /\[(?:(\d+)|['"](.*?)['"])\]|((?:(?!\[.*?\]|\.).)+)/g;
//# sourceMappingURL=index.js.map